import { Component, ViewChild } from "@angular/core"
import { TitleService } from "@puntaje/shared/core"

@Component({
    templateUrl: "nomina_alumnos.component.html"
})
export class NominaAlumnosComponent {
    loggedLayoutTitle = "Cargar Nomina"
}
